export default __webpack_public_path__ + "static/media/tick.e14cb23e.png";